import { VehicleService } from 'api';
import { trimAllSpaces } from 'utils/text/trimWhitespace';
const getIsRegisteredVehicleBeingMovedToNewAgreement = async (vehicleRegNumber, countryCode) => {
  if (!vehicleRegNumber || !countryCode) return false;
  const trimmedReg = trimAllSpaces(vehicleRegNumber);
  if (!trimmedReg) return false;
  try {
    const isVehicleRegistered = await VehicleService.isRegisteredVehicleBeingMoved({
      regNumber: trimmedReg,
      countryCode
    });
    return isVehicleRegistered;
  } catch (e) {
    return false;
  }
};
export default getIsRegisteredVehicleBeingMovedToNewAgreement;